const MINUTE_MS = 60_000
const HOUR_MS = 60 * MINUTE_MS

function startOfDay(date: Date): number {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime()
}

/** When a chat was last used, as short as it can be while still being exact enough to find it. */
export function formatChatTime(iso: string, now: Date = new Date()): string {
  const date = new Date(iso)
  const elapsed = now.getTime() - date.getTime()
  const daysAgo = Math.round((startOfDay(now) - startOfDay(date)) / (24 * HOUR_MS))

  if (elapsed < MINUTE_MS) return 'Just now'
  if (elapsed < HOUR_MS) return `${Math.floor(elapsed / MINUTE_MS)}m ago`
  if (daysAgo === 0) return `${Math.floor(elapsed / HOUR_MS)}h ago`
  if (daysAgo === 1) return 'Yesterday'
  if (daysAgo < 7) return date.toLocaleDateString('en-US', { weekday: 'long' })
  if (date.getFullYear() === now.getFullYear()) {
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })
  }
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
}
